// extracted by mini-css-extract-plugin
export default {"container":"XkiJoN","label":"H6h9pK","tooltipContainer":"eSQAyZ","nameContainer":"HTN5Rd","nameButton":"zPdmV1","name":"QfOal5","tooltip":"pF7sVL","loader":"G0svNC"};